import { View } from '@adobe/react-spectrum';
// NOTE: This import is here to make sure that the Tags classes are included
import '@react/react-spectrum/TagList';
import React, { useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { commonApi, handleApiCall } from '@exchange-frontends/api';
// Monorepo shared components
import { useHandleApiCall, useRootHref } from '@exchange-frontends/custom-hooks';
import { azSort } from '@exchange-frontends/utils';

import { DetailHeading } from '../../../../../components/DetailHeading';
import { concatTags } from '../../../utils/general';
import { ConfigContext } from '../../App';

const getStandardTagsHandler = handleApiCall(commonApi.getStandardTags);

const SidebarTags = ({ customTags, standardTags, appType, type, isPreview }) => {
  const shouldFetch = Boolean(type && type !== 'cc');
  const { response: tagMap, loading: tagMapLoading } = useHandleApiCall({
    shouldFetch,
    shouldShowError: false,
    defaultLoadingState: shouldFetch,
    action: commonApi.getStandardTags,
    handler: getStandardTagsHandler,
  });
  const tags = concatTags(standardTags, customTags)
    .map((tagId) => tagMap?.find((tag) => tag?.value === tagId)?.label || tagId)
    .sort(azSort);
  const { ROUTES } = useContext(ConfigContext) ?? {};
  const browseLink = useRootHref(ROUTES?.BROWSE ?? '');

  return tags?.length > 0 && !tagMapLoading ? (
    <>
      <DetailHeading level={4}>Tags</DetailHeading>
      <View>
        <div aria-label="tags" className="spectrum-Tags">
          {tags?.map((tag) => (
            <RouterLink
              key={tag}
              data-testid="tag-display"
              className="spectrum-Tags-item"
              to={`${browseLink}/${type?.toLowerCase() === 'cc' ? 'cc' : 'ec'}/?${
                appType === 'integrations' ? 'cc_app_type=integrations&' : ''
              }q=${encodeURIComponent(tag)}&sort=RELEVANCE`}
              style={{ textDecoration: 'none', pointerEvents: isPreview ? 'none' : undefined }}
              data-launchid="Tags"
            >
              <span className="spectrum-Tags-itemLabel" style={{ pointerEvents: 'none' }}>
                {tag}
              </span>
            </RouterLink>
          ))}
        </div>
      </View>
    </>
  ) : null;
};

export default SidebarTags;
